import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/order/layer.order.mutation.gql"
import type {
  LayerOrderUpdateMutation,
  LayerOrderUpdateMutationVariables,
} from "@/v2-backoffice-client/layer/order/__types__/layer.order.mutation"

type Options = MutationHookOptions<
  LayerOrderUpdateMutation,
  LayerOrderUpdateMutationVariables
>

export function useLayerOrderUpdateMutation(options?: Options) {
  return useMutation<
    LayerOrderUpdateMutation,
    LayerOrderUpdateMutationVariables
  >(mutation, options)
}
